import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import VoiceRecorder from '../components/VoiceRecorder';
import PartnerChatWidget from '../components/PartnerChat';
import PartnerVacancies from '../components/PartnerVacancies';
import { openCommissionReceipt } from '../utils/commissionReceipt';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

const statusStyles = {
  Approved: 'bg-emerald-100 text-emerald-700',
  Rejected: 'bg-red-100 text-red-700',
  Contacted: 'bg-blue-100 text-blue-700',
  Pending: 'bg-yellow-100 text-yellow-700'
};

const INDIAN_STATES = [
  'Andhra Pradesh','Arunachal Pradesh','Assam','Bihar','Chhattisgarh','Goa','Gujarat',
  'Haryana','Himachal Pradesh','Jharkhand','Karnataka','Kerala','Madhya Pradesh',
  'Maharashtra','Manipur','Meghalaya','Mizoram','Nagaland','Odisha','Punjab',
  'Rajasthan','Sikkim','Tamil Nadu','Telangana','Tripura','Uttar Pradesh',
  'Uttarakhand','West Bengal',
  'Andaman and Nicobar Islands','Chandigarh','Dadra and Nagar Haveli and Daman and Diu',
  'Delhi','Jammu and Kashmir','Ladakh','Lakshadweep','Puducherry'
];

const DISTRICTS_BY_STATE = {
  'Kerala': ['Thiruvananthapuram','Kollam','Pathanamthitta','Alappuzha','Kottayam','Idukki','Ernakulam','Thrissur','Palakkad','Malappuram','Kozhikode','Wayanad','Kannur','Kasaragod'],
  'Tamil Nadu': ['Ariyalur','Chengalpattu','Chennai','Coimbatore','Cuddalore','Dharmapuri','Dindigul','Erode','Kallakurichi','Kancheepuram','Kanyakumari','Karur','Krishnagiri','Madurai','Mayiladuthurai','Nagapattinam','Namakkal','Nilgiris','Perambalur','Pudukkottai','Ramanathapuram','Ranipet','Salem','Sivaganga','Tenkasi','Thanjavur','Theni','Tiruchirappalli','Tirunelveli','Tirupattur','Tiruppur','Tiruvallur','Tiruvannamalai','Thoothukudi','Vellore','Villupuram','Virudhunagar'],
  'Karnataka': ['Bagalkot','Ballari','Belagavi','Bengaluru Rural','Bengaluru Urban','Bidar','Chamarajanagar','Chikkaballapur','Chikkamagaluru','Chitradurga','Dakshina Kannada','Davangere','Dharwad','Gadag','Hassan','Haveri','Kalaburagi','Kodagu','Kolar','Koppal','Mandya','Mysuru','Raichur','Ramanagara','Shivamogga','Tumakuru','Udupi','Uttara Kannada','Vijayapura','Yadgir'],
  'Andhra Pradesh': ['Alluri Sitharama Raju','Anakapalli','Ananthapuramu','Annamayya','Bapatla','Chittoor','East Godavari','Eluru','Guntur','Kakinada','Krishna','Kurnool','Nandyal','NTR','Palnadu','Parvathipuram Manyam','Prakasam','Srikakulam','Sri Sathya Sai','Tirupati','Visakhapatnam','Vizianagaram','West Godavari','YSR Kadapa'],
  'Telangana': ['Adilabad','Bhadradri Kothagudem','Hanumakonda','Hyderabad','Jagtial','Jangaon','Jayashankar Bhupalpally','Jogulamba Gadwal','Kamareddy','Karimnagar','Khammam','Komaram Bheem','Mahabubabad','Mahabubnagar','Mancherial','Medak','Medchal Malkajgiri','Mulugu','Nagarkurnool','Nalgonda','Narayanpet','Nirmal','Nizamabad','Peddapalli','Rajanna Sircilla','Rangareddy','Sangareddy','Siddipet','Suryapet','Vikarabad','Wanaparthy','Warangal','Yadadri Bhuvanagiri'],
  'Maharashtra': ['Ahmednagar','Akola','Amravati','Aurangabad','Beed','Bhandara','Buldhana','Chandrapur','Dhule','Gadchiroli','Gondia','Hingoli','Jalgaon','Jalna','Kolhapur','Latur','Mumbai City','Mumbai Suburban','Nagpur','Nanded','Nandurbar','Nashik','Osmanabad','Palghar','Parbhani','Pune','Raigad','Ratnagiri','Sangli','Satara','Sindhudurg','Solapur','Thane','Wardha','Washim','Yavatmal'],
  'Gujarat': ['Ahmedabad','Amreli','Anand','Aravalli','Banaskantha','Bharuch','Bhavnagar','Botad','Chhota Udaipur','Dahod','Dang','Devbhoomi Dwarka','Gandhinagar','Gir Somnath','Jamnagar','Junagadh','Kheda','Kutch','Mahisagar','Mehsana','Morbi','Narmada','Navsari','Panchmahal','Patan','Porbandar','Rajkot','Sabarkantha','Surat','Surendranagar','Tapi','Vadodara','Valsad'],
  'Rajasthan': ['Ajmer','Alwar','Banswara','Baran','Barmer','Bharatpur','Bhilwara','Bikaner','Bundi','Chittorgarh','Churu','Dausa','Dholpur','Dungarpur','Hanumangarh','Jaipur','Jaisalmer','Jalore','Jhalawar','Jhunjhunu','Jodhpur','Karauli','Kota','Nagaur','Pali','Pratapgarh','Rajsamand','Sawai Madhopur','Sikar','Sirohi','Sri Ganganagar','Tonk','Udaipur'],
  'Delhi': ['Central Delhi','East Delhi','New Delhi','North Delhi','North East Delhi','North West Delhi','Shahdara','South Delhi','South East Delhi','South West Delhi','West Delhi'],
  'West Bengal': ['Alipurduar','Bankura','Birbhum','Cooch Behar','Dakshin Dinajpur','Darjeeling','Hooghly','Howrah','Jalpaiguri','Jhargram','Kalimpong','Kolkata','Malda','Murshidabad','Nadia','North 24 Parganas','Paschim Bardhaman','Paschim Medinipur','Purba Bardhaman','Purba Medinipur','Purulia','South 24 Parganas','Uttar Dinajpur'],
  'Punjab': ['Amritsar','Barnala','Bathinda','Faridkot','Fatehgarh Sahib','Fazilka','Ferozepur','Gurdaspur','Hoshiarpur','Jalandhar','Kapurthala','Ludhiana','Malerkotla','Mansa','Moga','Mohali','Muktsar','Pathankot','Patiala','Rupnagar','Sangrur','Shaheed Bhagat Singh Nagar','Tarn Taran'],
  'Haryana': ['Ambala','Bhiwani','Charkhi Dadri','Faridabad','Fatehabad','Gurugram','Hisar','Jhajjar','Jind','Kaithal','Karnal','Kurukshetra','Mahendragarh','Nuh','Palwal','Panchkula','Panipat','Rewari','Rohtak','Sirsa','Sonipat','Yamunanagar'],
  'Uttar Pradesh': ['Agra','Aligarh','Ambedkar Nagar','Amethi','Amroha','Auraiya','Ayodhya','Azamgarh','Baghpat','Bahraich','Ballia','Balrampur','Banda','Barabanki','Bareilly','Basti','Bhadohi','Bijnor','Budaun','Bulandshahr','Chandauli','Chitrakoot','Deoria','Etah','Etawah','Farrukhabad','Fatehpur','Firozabad','Gautam Buddha Nagar','Ghaziabad','Ghazipur','Gonda','Gorakhpur','Hamirpur','Hapur','Hardoi','Hathras','Jalaun','Jaunpur','Jhansi','Kannauj','Kanpur Dehat','Kanpur Nagar','Kasganj','Kaushambi','Kushinagar','Lakhimpur Kheri','Lalitpur','Lucknow','Maharajganj','Mahoba','Mainpuri','Mathura','Mau','Meerut','Mirzapur','Moradabad','Muzaffarnagar','Pilibhit','Pratapgarh','Prayagraj','Rae Bareli','Rampur','Saharanpur','Sambhal','Sant Kabir Nagar','Shahjahanpur','Shamli','Shravasti','Siddharthnagar','Sitapur','Sonbhadra','Sultanpur','Unnao','Varanasi'],
  'Bihar': ['Araria','Arwal','Aurangabad','Banka','Begusarai','Bhagalpur','Bhojpur','Buxar','Darbhanga','East Champaran','Gaya','Gopalganj','Jamui','Jehanabad','Kaimur','Katihar','Khagaria','Kishanganj','Lakhisarai','Madhepura','Madhubani','Munger','Muzaffarpur','Nalanda','Nawada','Patna','Purnia','Rohtas','Saharsa','Samastipur','Saran','Sheikhpura','Sheohar','Sitamarhi','Siwan','Supaul','Vaishali','West Champaran'],
  'Madhya Pradesh': ['Agar Malwa','Alirajpur','Anuppur','Ashoknagar','Balaghat','Barwani','Betul','Bhind','Bhopal','Burhanpur','Chhatarpur','Chhindwara','Damoh','Datia','Dewas','Dhar','Dindori','Guna','Gwalior','Harda','Hoshangabad','Indore','Jabalpur','Jhabua','Katni','Khandwa','Khargone','Mandla','Mandsaur','Morena','Narsinghpur','Neemuch','Niwari','Panna','Raisen','Rajgarh','Ratlam','Rewa','Sagar','Satna','Sehore','Seoni','Shahdol','Shajapur','Sheopur','Shivpuri','Sidhi','Singrauli','Tikamgarh','Ujjain','Umaria','Vidisha'],
  'Odisha': ['Angul','Balangir','Balasore','Bargarh','Bhadrak','Boudh','Cuttack','Deogarh','Dhenkanal','Gajapati','Ganjam','Jagatsinghpur','Jajpur','Jharsuguda','Kalahandi','Kandhamal','Kendrapara','Kendujhar','Khordha','Koraput','Malkangiri','Mayurbhanj','Nabarangpur','Nayagarh','Nuapada','Puri','Rayagada','Sambalpur','Sonepur','Sundargarh']
};

const JOB_ROLES = ['Accountant','Accounts Assistant','Accounts Executive','Administrative Assistant','Area Sales Manager','Architect','Auditor','Backend Developer','Bank Clerk','BDM','BDE','Branch Manager','Business Analyst','Call Centre Executive','Cashier','Chef / Cook','Civil Engineer','Clinical Pharmacist','Computer Operator','Content Writer','Customer Service Executive','Data Analyst','Data Entry Operator','Digital Marketing Executive','Driver','Electrical Engineer','Electronics Technician','Field Sales Executive','Finance Executive','Finance Manager','Front Office Executive','Full Stack Developer','General Manager','Graphic Designer','HR Executive','HR Manager','Interior Designer','IT Support Engineer','Junior Accountant','Lab Technician','Logistics Executive','Machine Operator','Marketing Executive','Marketing Manager','Mechanical Engineer','Medical Representative','Network Administrator','Nurse (GNM / B.Sc)','Office Assistant','Operations Executive','Operations Manager','Pharmacist','Production Engineer','Purchase Executive','Quality Analyst','QA Engineer','Receptionist','Sales Coordinator','Sales Executive','Sales Manager','SAP Consultant','Security Guard','SEO Executive','Site Engineer','Social Media Manager','Software Developer','Software Tester','Store Keeper','Supervisor','System Administrator','Tax Consultant','Teacher / Faculty','Team Leader','Technician','Telecaller','UI/UX Designer','Videographer / Photographer','Warehouse Executive','Web Developer','Welder'];

const initialForm = {
  name: '',
  contact_number: '',
  whatsapp_number: '',
  age: '',
  gender: 'Male',
  place: '',
  state: '',
  district: '',
  qualification: '',
  experience_level: 'Fresher',
  expecting_job: '',
  resume: null,
  remarks: '',
  voice_note: null,
  remove_voice_note: false
};

const inputClassName = 'mt-1.5 w-full rounded-xl border border-yellow-200 bg-yellow-50/60 px-4 py-2.5 text-black outline-none focus:border-yellow-400 focus:bg-white focus:ring-2 focus:ring-yellow-300 transition';

const PAGE_SIZE = 10;
const RESUME_MAX_BYTES = 3 * 1024 * 1024; // must match PARTNER_RESUME_MAX_BYTES on the server
const formatFileSize = (bytes) => (bytes >= 1024 * 1024 ? `${(bytes / (1024 * 1024)).toFixed(1)} MB` : `${Math.max(1, Math.round(bytes / 1024))} KB`);

// Before the server tracked it, "popup already shown" was kept in this browser; still honoured so those don't repeat
const readLegacySeenPlacements = (partnerId) => {
  try { return JSON.parse(localStorage.getItem(`djc_seen_placements_${partnerId}`) || '[]'); } catch { return []; }
};

const voiceNoteFileName = (blob) => `voice-note.${/mp4/.test(blob.type) ? 'm4a' : /ogg/.test(blob.type) ? 'ogg' : 'webm'}`;

const formatPlacedDate = (value) => (value ? String(value).slice(0, 10) : '');

const Paginator = ({ page, total, pageSize, onChange }) => {
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  if (total === 0) return null;
  const safePage = Math.min(Math.max(page, 1), totalPages);
  const pages = [];
  const delta = 2;
  for (let i = 1; i <= totalPages; i++) {
    if (i === 1 || i === totalPages || (i >= safePage - delta && i <= safePage + delta)) {
      pages.push(i);
    } else if (pages[pages.length - 1] !== '…') {
      pages.push('…');
    }
  }
  return (
    <div className="flex items-center justify-between flex-wrap gap-3 px-1 pt-3 border-t border-yellow-100">
      <p className="text-xs font-semibold text-gray-500">
        Showing {(safePage - 1) * pageSize + 1}–{Math.min(safePage * pageSize, total)} of {total} &middot; Page {safePage} of {totalPages}
      </p>
      <div className="flex flex-wrap items-center gap-1">
        <button
          type="button"
          onClick={() => onChange(1)}
          disabled={safePage <= 1}
          className="rounded-lg border border-yellow-200 bg-white px-3 py-1.5 text-xs font-black text-black hover:bg-yellow-50 disabled:opacity-30"
        >
          « First
        </button>
        <button
          type="button"
          onClick={() => onChange(safePage - 1)}
          disabled={safePage <= 1}
          className="rounded-lg border border-yellow-200 bg-white px-3 py-1.5 text-xs font-black text-black hover:bg-yellow-50 disabled:opacity-30"
        >
          ← Prev
        </button>
        {pages.map((p, i) =>
          p === '…' ? (
            <span key={`ellipsis-${i}`} className="px-1.5 text-xs text-gray-400">…</span>
          ) : (
            <button
              key={p}
              type="button"
              onClick={() => onChange(p)}
              className={`rounded-lg border px-3 py-1.5 text-xs font-black transition ${
                p === safePage
                  ? 'border-yellow-400 bg-yellow-400 text-black'
                  : 'border-yellow-200 bg-white text-black hover:bg-yellow-50'
              }`}
            >
              {p}
            </button>
          )
        )}
        <button
          type="button"
          onClick={() => onChange(safePage + 1)}
          disabled={safePage >= totalPages}
          className="rounded-lg border border-yellow-200 bg-white px-3 py-1.5 text-xs font-black text-black hover:bg-yellow-50 disabled:opacity-30"
        >
          Next →
        </button>
        <button
          type="button"
          onClick={() => onChange(totalPages)}
          disabled={safePage >= totalPages}
          className="rounded-lg border border-yellow-200 bg-white px-3 py-1.5 text-xs font-black text-black hover:bg-yellow-50 disabled:opacity-30"
        >
          Last »
        </button>
      </div>
    </div>
  );
};

const PartnerDashboard = () => {
  const navigate = useNavigate();
  const [partner, setPartner] = useState(null);
  const [registrations, setRegistrations] = useState([]);
  const [activeTab, setActiveTab] = useState('register');
  const [form, setForm] = useState(initialForm);
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [feedback, setFeedback] = useState('');
  const [summary, setSummary] = useState(null);
  const [commissions, setCommissions] = useState([]);
  const [commissionsLoading, setCommissionsLoading] = useState(false);
  const [membersPage, setMembersPage] = useState(1);
  const [commissionsPage, setCommissionsPage] = useState(1);
  const [newPlacements, setNewPlacements] = useState([]);
  const [editingVacancy, setEditingVacancy] = useState(null);
  const [commissionFilter, setCommissionFilter] = useState({ source: '', status: '' }); // shared vacancy being corrected in the Register Vacancy tab
  const [resumeError, setResumeError] = useState('');
  const [editingMember, setEditingMember] = useState(null);
  const [formVersion, setFormVersion] = useState(0); // bumped on every form reset so the voice recorder resets too // member being corrected in the register form

  useEffect(() => {
    const token = localStorage.getItem('token');
    const user = JSON.parse(localStorage.getItem('user') || 'null');

    if (!token || !user || user.type !== 'partner') {
      navigate('/login');
      return;
    }

    const fetchDashboard = async () => {
      setLoading(true);
      setError('');
      try {
        const res = await axios.get(`${API_URL}/api/partner/dashboard`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        setPartner(res.data?.partner || null);
        setRegistrations(res.data?.registrations || []);
        setSummary(res.data?.summary || null);

        // Congratulate the partner exactly once per placed member: the server remembers it was shown
        const unseenPlaced = (res.data?.registrations || []).filter((r) => r.is_placed && !Number(r.placement_popup_seen));
        if (unseenPlaced.length > 0) {
          const legacySeen = readLegacySeenPlacements(res.data?.partner?.id);
          setNewPlacements(unseenPlaced.filter((r) => !legacySeen.includes(r.id)));
          axios.post(`${API_URL}/api/partner/placements/seen`, { ids: unseenPlaced.map((r) => r.id) }, {
            headers: { Authorization: `Bearer ${token}` }
          }).catch(() => {});
        }
      } catch (err) {
        setError(err?.response?.data?.error || 'Failed to load partner dashboard.');
      } finally {
        setLoading(false);
      }
    };

    fetchDashboard();
  }, [navigate]);

  const fetchCommissions = async () => {
    setCommissionsLoading(true);
    try {
      const token = localStorage.getItem('token');
      const res = await axios.get(`${API_URL}/api/partner/commissions`, { headers: { Authorization: `Bearer ${token}` } });
      setCommissions(res.data || []);
    } catch {
      setCommissions([]);
    } finally {
      setCommissionsLoading(false);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    navigate('/login');
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'contact_number' || name === 'whatsapp_number') {
      setForm((prev) => ({ ...prev, [name]: value.replace(/\D/g, '').slice(0, 10) }));
      return;
    }
    if (name === 'age') {
      setForm((prev) => ({ ...prev, age: value.replace(/\D/g, '').slice(0, 2) }));
      return;
    }
    if (name === 'state') {
      setForm((prev) => ({ ...prev, state: value, district: '' }));
      return;
    }
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files && e.target.files[0] ? e.target.files[0] : null;
    if (file) {
      const isAllowedType = /\.(pdf|jpe?g)$/i.test(file.name) || ['application/pdf', 'image/jpeg'].includes(file.type);
      const problem = !isAllowedType
        ? 'Resume must be a PDF or JPG file.'
        : file.size > RESUME_MAX_BYTES
          ? `Resume is ${formatFileSize(file.size)}. Please upload a file smaller than 3 MB.`
          : '';
      if (problem) {
        e.target.value = '';
        setResumeError(problem);
        setForm((prev) => ({ ...prev, resume: null }));
        return;
      }
    }
    setResumeError('');
    setForm((prev) => ({ ...prev, resume: file }));
  };

  const startEditMember = (member) => {
    setEditingMember(member);
    setForm({
      name: member.name || '',
      contact_number: member.contact_number || '',
      whatsapp_number: member.whatsapp_number || '',
      age: String(member.age || ''),
      gender: member.gender || 'Male',
      place: member.place || '',
      state: member.state || 'Kerala',
      district: member.district || '',
      qualification: member.qualification || '',
      experience_level: member.experience_level || 'Fresher',
      expecting_job: member.expecting_job || '',
      resume: null,
      remarks: member.remarks || '',
      voice_note: null,
      remove_voice_note: false
    });
    setFormVersion((v) => v + 1);
    setError('');
    setFeedback('');
    setActiveTab('register');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const cancelEditMember = () => {
    setEditingMember(null);
    setForm(initialForm);
    setFormVersion((v) => v + 1);
    setError('');
    setActiveTab('submitted');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!/^\d{10}$/.test(form.contact_number) || !/^\d{10}$/.test(form.whatsapp_number)) {
      setError('Contact number and WhatsApp number must be exactly 10 digits.');
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }
    setSubmitting(true);
    setError('');
    setFeedback('');

    if (editingMember) {
      try {
        const token = localStorage.getItem('token');
        const formData = new FormData();
        ['name', 'contact_number', 'whatsapp_number', 'age', 'gender', 'place', 'state', 'district',
          'qualification', 'experience_level', 'expecting_job', 'remarks'].forEach((key) => formData.append(key, form[key]));
        if (form.resume) formData.append('resume', form.resume);
        if (form.voice_note) formData.append('voice_note', form.voice_note, voiceNoteFileName(form.voice_note));
        else if (form.remove_voice_note) formData.append('remove_voice_note', '1');

        const res = await axios.put(`${API_URL}/api/partner/registrations/${editingMember.id}`, formData, {
          headers: { Authorization: `Bearer ${token}` }
        });
        setRegistrations((prev) => prev.map((r) => (r.id === editingMember.id ? res.data.registration : r)));
        setFeedback(`${res.data.registration?.name || 'Member'}'s details were updated.`);
        setEditingMember(null);
        setForm(initialForm);
    setFormVersion((v) => v + 1);
        setActiveTab('submitted');
      } catch (err) {
        setError(err?.response?.data?.error || 'Failed to update member details.');
      } finally {
        setSubmitting(false);
      }
      return;
    }

    try {
      const token = localStorage.getItem('token');
      const formData = new FormData();
      formData.append('name', form.name);
      formData.append('contact_number', form.contact_number);
      formData.append('whatsapp_number', form.whatsapp_number);
      formData.append('age', form.age);
      formData.append('gender', form.gender);
      formData.append('place', form.place);
      formData.append('state', form.state);
      formData.append('district', form.district);
      formData.append('qualification', form.qualification);
      formData.append('experience_level', form.experience_level);
      formData.append('expecting_job', form.expecting_job);
      formData.append('remarks', form.remarks);
      if (form.resume) formData.append('resume', form.resume);
      if (form.voice_note) formData.append('voice_note', form.voice_note, voiceNoteFileName(form.voice_note));

      const res = await axios.post(`${API_URL}/api/partner/registrations`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data'
        }
      });

      setRegistrations((prev) => [res.data.registration, ...prev]);
      setForm(initialForm);
    setFormVersion((v) => v + 1);
      setFeedback(res.data?.message || 'Member registration submitted successfully.');
    } catch (err) {
      const responseMessage = typeof err?.response?.data === 'string'
        ? err.response.data
        : err?.response?.data?.error;
      setError(responseMessage || `Failed to submit partner member registration${err?.response?.status ? ` (${err.response.status})` : ''}.`);
    } finally {
      setSubmitting(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-[linear-gradient(180deg,#fffdf4_0%,#ffffff_100%)] px-4 py-10">
        <div className="mx-auto max-w-7xl rounded-[32px] border border-yellow-200 bg-white px-6 py-8 shadow-[0_24px_70px_rgba(0,0,0,0.08)]">
          Loading partner dashboard...
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[linear-gradient(160deg,#fefce8_0%,#fef9c3_30%,#ffffff_70%)] px-4 py-6 md:px-6 md:py-8">
      <div className="mx-auto max-w-7xl space-y-5">

        {/* ── HEADER BANNER ───────────────────────────────────────────── */}
        <section className="overflow-hidden rounded-[32px] bg-black px-5 py-6 shadow-[0_20px_56px_rgba(0,0,0,0.22)] md:px-8">
          <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
            <div>
              <p className="text-xs font-black uppercase tracking-[0.36em] text-yellow-400">Partner Dashboard</p>
              <h1 className="mt-2 text-2xl font-black tracking-tight text-white md:text-3xl">
                {partner?.name_of_organisation || 'Partner Account'}
              </h1>
              {partner?.owner_of_organisation && (
                <p className="mt-1 text-sm text-yellow-200 font-semibold">{partner.owner_of_organisation}</p>
              )}
            </div>
            <div className="flex flex-wrap items-center gap-3">
              <span className={`rounded-full px-4 py-1.5 text-sm font-black border ${
                partner?.partnership_status === 'Approved' ? 'bg-yellow-400 text-black border-yellow-400' :
                partner?.partnership_status === 'Rejected' ? 'bg-red-500 text-white border-red-500' :
                'bg-yellow-400/20 text-yellow-300 border-yellow-400/40'
              }`}>
                {partner?.partnership_status || 'Pending'}
              </span>
              <button
                type="button"
                onClick={handleLogout}
                className="rounded-xl bg-yellow-400 px-5 py-2 text-sm font-black text-black hover:bg-yellow-300 transition"
              >
                Logout
              </button>
            </div>
          </div>
        </section>

        {(error || feedback) && (
          <div className={`rounded-2xl border px-4 py-3 text-sm font-semibold ${error ? 'border-red-200 bg-red-50 text-red-700' : 'border-emerald-200 bg-emerald-50 text-emerald-700'}`}>
            {error || feedback}
          </div>
        )}

        {/* ── SUMMARY STATS ───────────────────────────────────────────── */}
        {summary && (
          <section className="grid grid-cols-2 gap-3 sm:grid-cols-4 lg:grid-cols-8">
            {[
              { val: summary.total_submitted,        label: 'Uploaded',           bg: 'bg-white',              border: 'border-yellow-200', num: 'text-black',       sub: 'text-gray-500' },
              { val: summary.forwarded_to_hr,        label: 'Sent to HR',         bg: 'bg-yellow-50',          border: 'border-yellow-300', num: 'text-yellow-800',  sub: 'text-yellow-600' },
              { val: summary.pending_review,         label: 'Pending',            bg: 'bg-black',              border: 'border-black',      num: 'text-yellow-400',  sub: 'text-yellow-200' },
              { val: summary.placed,                 label: 'Placed',             bg: 'bg-yellow-400',         border: 'border-yellow-400', num: 'text-black',       sub: 'text-black/70' },
              { val: summary.vacancies_shared || 0,  label: 'Vacancies Shared',   bg: 'bg-white',              border: 'border-yellow-300', num: 'text-black',       sub: 'text-gray-500' },
              { val: summary.vacancy_placed || 0,    label: 'Vacancy Placements', bg: 'bg-yellow-50',          border: 'border-yellow-300', num: 'text-yellow-800',  sub: 'text-yellow-600' },
              { val: `₹${Number(summary.commission_pending_amount || 0).toLocaleString('en-IN')}`, label: `Pending (${summary.commission_pending || 0})`, bg: 'bg-white', border: 'border-yellow-300', num: 'text-black', sub: 'text-gray-500' },
              { val: `₹${Number(summary.total_commission_earned || 0).toLocaleString('en-IN')}`, label: `Paid (${summary.commission_paid || 0})`, bg: 'bg-black', border: 'border-black', num: 'text-yellow-400', sub: 'text-yellow-200' },
            ].map((s) => (
              <div key={s.label} className={`rounded-[22px] border ${s.border} ${s.bg} px-4 py-4 shadow-sm text-center`}>
                <p className={`text-2xl font-black ${s.num}`}>{s.val}</p>
                <p className={`mt-1 text-[10px] font-black uppercase tracking-[0.18em] ${s.sub}`}>{s.label}</p>
              </div>
            ))}
          </section>
        )}

        {/* ── TABS CARD ───────────────────────────────────────────────── */}
        <section>
          <div className="rounded-[30px] border border-yellow-200 bg-white p-5 shadow-[0_12px_40px_rgba(250,204,21,0.10)]">
            <div className="flex flex-wrap gap-2 border-b border-yellow-100 pb-3">
              {[
                { key: 'register',    label: 'Register Member' },
                { key: 'vacancy',     label: '🏢 Register Vacancy', onSwitch: () => setEditingVacancy(null) },
                { key: 'vacancies',   label: 'Shared Vacancies' },
                { key: 'submitted',   label: 'Submitted Members', onSwitch: () => setMembersPage(1) },
                { key: 'commissions', label: '💰 My Commissions', onSwitch: () => { setCommissionsPage(1); fetchCommissions(); } },
              ].map((t) => (
              <button
                key={t.key}
                type="button"
                onClick={() => { setActiveTab(t.key); t.onSwitch?.(); }}
                className={`rounded-full px-5 py-2 text-sm font-black uppercase tracking-[0.14em] transition ${
                  activeTab === t.key
                    ? 'bg-yellow-400 text-black shadow-sm'
                    : 'border border-yellow-200 bg-white text-black hover:bg-yellow-50 hover:border-yellow-400'
                }`}
              >
                {t.label}
              </button>
              ))}
            </div>

            {activeTab === 'register' ? (
              <>
                {editingMember ? (
                  <div className="mt-4 flex flex-wrap items-center justify-between gap-3 rounded-2xl border border-blue-200 bg-blue-50 px-4 py-3">
                    <div>
                      <p className="text-xs font-black uppercase tracking-[0.28em] text-blue-600">Edit Member</p>
                      <h2 className="mt-1 text-xl font-black text-black">Correcting: {editingMember.name}</h2>
                      <p className="text-xs text-gray-600">Fix the details below and save. Leave the resume empty to keep the current one.</p>
                    </div>
                    <button type="button" onClick={cancelEditMember} className="rounded-xl border border-gray-300 bg-white px-4 py-2 text-sm font-black text-black hover:border-blue-400">
                      ✕ Cancel Edit
                    </button>
                  </div>
                ) : (
                  <>
                    <p className="mt-4 text-xs font-black uppercase tracking-[0.28em] text-yellow-600">Register Member</p>
                    <h2 className="mt-1 text-2xl font-black text-black">Submit member details</h2>
                  </>
                )}

                <form onSubmit={handleSubmit} className="mt-5 grid grid-cols-1 gap-3 md:grid-cols-2">
                  <label className="block md:col-span-2">
                    <span className="text-sm font-bold text-black">Name</span>
                    <input name="name" value={form.name} onChange={handleChange} className={inputClassName} required />
                  </label>

                  <label className="block">
                    <span className="text-sm font-bold text-black">Contact Number</span>
                    <input name="contact_number" value={form.contact_number} onChange={handleChange} inputMode="numeric" maxLength={10} pattern="\d{10}" title="Enter exactly 10 digits" placeholder="10-digit mobile number" className={inputClassName} required />
                    {form.contact_number && form.contact_number.length !== 10 && (
                      <span className="mt-1 block text-xs font-bold text-red-600">{form.contact_number.length}/10 digits · must be exactly 10</span>
                    )}
                  </label>

                  <label className="block">
                    <span className="text-sm font-bold text-black">WhatsApp Number</span>
                    <input name="whatsapp_number" value={form.whatsapp_number} onChange={handleChange} inputMode="numeric" maxLength={10} pattern="\d{10}" title="Enter exactly 10 digits" placeholder="10-digit mobile number" className={inputClassName} required />
                    {form.whatsapp_number && form.whatsapp_number.length !== 10 && (
                      <span className="mt-1 block text-xs font-bold text-red-600">{form.whatsapp_number.length}/10 digits · must be exactly 10</span>
                    )}
                  </label>

                  <label className="block">
                    <span className="text-sm font-bold text-black">Age</span>
                    <input name="age" value={form.age} onChange={handleChange} className={inputClassName} required />
                  </label>

                  <label className="block">
                    <span className="text-sm font-bold text-black">Gender</span>
                    <select name="gender" value={form.gender} onChange={handleChange} className={inputClassName}>
                      <option value="Male">Male</option>
                      <option value="Female">Female</option>
                    </select>
                  </label>

                  <label className="block">
                    <span className="text-sm font-bold text-black">Place</span>
                    <input name="place" value={form.place} onChange={handleChange} className={inputClassName} required />
                  </label>

                  <label className="block">
                    <span className="text-sm font-bold text-black">State</span>
                    <select name="state" value={form.state} onChange={handleChange} className={inputClassName} required>
                      <option value="">Select State</option>
                      {INDIAN_STATES.map((s) => <option key={s} value={s}>{s}</option>)}
                    </select>
                  </label>

                  <label className="block md:col-span-2">
                    <span className="text-sm font-bold text-black">District</span>
                    <input
                      name="district"
                      list="partner-districts-list"
                      autoComplete="off"
                      value={form.district}
                      onChange={handleChange}
                      className={inputClassName}
                      placeholder={form.state && DISTRICTS_BY_STATE[form.state] ? 'Select or type district' : 'Type district name'}
                      required
                    />
                    <datalist id="partner-districts-list">
                      {(DISTRICTS_BY_STATE[form.state] || []).map((d) => <option key={d} value={d} />)}
                    </datalist>
                  </label>

                  <label className="block md:col-span-2">
                    <span className="text-sm font-bold text-black">Qualification</span>
                    <input name="qualification" value={form.qualification} onChange={handleChange} className={inputClassName} required />
                  </label>

                  <label className="block">
                    <span className="text-sm font-bold text-black">Experience</span>
                    <select name="experience_level" value={form.experience_level} onChange={handleChange} className={inputClassName}>
                      <option value="Fresher">Fresher</option>
                      <option value="Experienced">Experienced</option>
                    </select>
                  </label>

                  <label className="block">
                    <span className="text-sm font-bold text-black">Expecting Job</span>
                    <input
                      name="expecting_job"
                      list="partner-jobroles-list"
                      autoComplete="off"
                      value={form.expecting_job}
                      onChange={handleChange}
                      className={inputClassName}
                      placeholder="Select or type job role"
                      required
                    />
                    <datalist id="partner-jobroles-list">
                      {JOB_ROLES.map((j) => <option key={j} value={j} />)}
                    </datalist>
                  </label>

                  <label className="block md:col-span-2">
                    <span className="text-sm font-bold text-black">{editingMember ? 'Replace Resume (PDF / JPG, max 3 MB, optional)' : 'Upload Resume (PDF / JPG, max 3 MB)'}</span>
                    <input key={editingMember ? `resume-${editingMember.id}` : 'resume-new'} type="file" accept="application/pdf,.pdf,image/jpeg,.jpg,.jpeg" onChange={handleFileChange} className={`${inputClassName} file:mr-4 file:rounded-xl file:border-0 file:bg-yellow-400 file:px-4 file:py-2 file:font-bold file:text-black`} required={!editingMember} />
                    <span className="mt-2 block text-xs text-gray-500">
                      {form.resume ? `✓ ${form.resume.name} (${formatFileSize(form.resume.size)})` : editingMember ? (
                        editingMember.resume_file
                          ? <>Keeping current resume · <a href={`${API_URL}${editingMember.resume_file}`} target="_blank" rel="noreferrer" className="font-bold text-blue-600 underline">View</a></>
                          : 'No resume on file'
                      ) : 'No file selected yet · PDF or JPG, below 3 MB'}
                    </span>
                    {resumeError && <span className="mt-1 block text-xs font-bold text-red-600">⚠ {resumeError}</span>}
                  </label>

                  <label className="block md:col-span-2">
                    <span className="text-sm font-bold text-black">Remarks <span className="font-normal text-gray-500">(optional)</span></span>
                    <textarea
                      name="remarks"
                      value={form.remarks}
                      onChange={handleChange}
                      rows={3}
                      maxLength={2000}
                      placeholder="Anything we should know about this member: availability, special skills, preferred location…"
                      className={inputClassName}
                    />
                  </label>

                  <div className="md:col-span-2">
                    <span className="text-sm font-bold text-black">Voice Note <span className="font-normal text-gray-500">(optional)</span></span>
                    <VoiceRecorder
                      key={formVersion}
                      onChange={(blob) => setForm((prev) => ({ ...prev, voice_note: blob, remove_voice_note: false }))}
                      existingUrl={editingMember && editingMember.voice_note_file && !form.remove_voice_note ? `${API_URL}${editingMember.voice_note_file}` : ''}
                      onRemoveExisting={() => setForm((prev) => ({ ...prev, remove_voice_note: true }))}
                    />
                    {editingMember && form.remove_voice_note && (
                      <p className="mt-1 text-xs font-bold text-red-600">
                        Saved voice note will be removed. <button type="button" onClick={() => setForm((prev) => ({ ...prev, remove_voice_note: false }))} className="underline">Undo</button>
                      </p>
                    )}
                  </div>

                  <div className="md:col-span-2 flex justify-end gap-2">
                    {editingMember && (
                      <button type="button" onClick={cancelEditMember} className="rounded-xl border border-gray-300 bg-white px-6 py-3 font-black text-black hover:border-yellow-400 transition">
                        Cancel
                      </button>
                    )}
                    <button type="submit" disabled={submitting} className="rounded-xl bg-yellow-400 px-8 py-3 font-black text-black hover:bg-yellow-300 disabled:opacity-60 shadow-sm transition">
                      {submitting ? (editingMember ? 'Saving…' : 'Submitting…') : (editingMember ? 'Save Changes' : 'Submit Member Registration')}
                    </button>
                  </div>
                </form>
              </>
            ) : activeTab === 'vacancy' ? (
              <PartnerVacancies
                mode="form"
                editing={editingVacancy}
                states={INDIAN_STATES}
                districtsByState={DISTRICTS_BY_STATE}
                jobRoles={JOB_ROLES}
                onSaved={(saved, wasEdit) => {
                  setSummary((prev) => (prev && !wasEdit ? { ...prev, vacancies_shared: (prev.vacancies_shared || 0) + 1 } : prev));
                  if (wasEdit) { setEditingVacancy(null); setActiveTab('vacancies'); }
                }}
                onCancelEdit={() => { setEditingVacancy(null); setActiveTab('vacancies'); }}
              />
            ) : activeTab === 'vacancies' ? (
              <PartnerVacancies
                mode="list"
                Paginator={Paginator}
                onEdit={(v) => { setEditingVacancy(v); setActiveTab('vacancy'); window.scrollTo({ top: 0, behavior: 'smooth' }); }}
              />
            ) : activeTab === 'commissions' ? ((() => {
              const money = (list) => list.reduce((sum, c) => sum + (parseFloat(c.commission_amount || '0') || 0), 0);
              const rupees = (n) => `₹${n.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
              const isVacancy = (c) => c.source_type === 'vacancy';
              const pendingList = commissions.filter((c) => c.status !== 'Paid');
              const paidList = commissions.filter((c) => c.status === 'Paid');
              const shown = commissions.filter((c) => (
                (!commissionFilter.source || (commissionFilter.source === 'vacancy') === isVacancy(c))
                && (!commissionFilter.status || (commissionFilter.status === 'Paid') === (c.status === 'Paid'))
              ));
              const safeCPage = Math.min(Math.max(commissionsPage, 1), Math.max(1, Math.ceil(shown.length / PAGE_SIZE)));
              const pagedC = shown.slice((safeCPage - 1) * PAGE_SIZE, safeCPage * PAGE_SIZE);
              const setCF = (name, value) => { setCommissionFilter((prev) => ({ ...prev, [name]: value })); setCommissionsPage(1); };
              return (
              <>
                <div className="mt-4 flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
                  <div>
                    <p className="text-xs font-black uppercase tracking-[0.28em] text-yellow-600">My Commissions</p>
                    <h2 className="mt-1 text-xl font-black text-black">Commission earnings</h2>
                    <p className="text-sm text-gray-500">You earn the same commission for every placement: members you refer and vacancies you share.</p>
                  </div>
                  <button type="button" onClick={fetchCommissions} className="w-fit rounded-xl border border-yellow-300 bg-white px-4 py-2 text-sm font-black text-black hover:bg-yellow-50">↺ Refresh</button>
                </div>

                <div className="mt-4 grid grid-cols-2 gap-3 lg:grid-cols-5">
                  {[
                    { label: 'Total Commission', value: rupees(money(commissions)), sub: `${commissions.length} placement${commissions.length === 1 ? '' : 's'}`, cls: 'bg-black text-yellow-400 border-black', subCls: 'text-yellow-200' },
                    { label: 'Pending Payment', value: rupees(money(pendingList)), sub: `${pendingList.length} awaiting`, cls: 'bg-yellow-400 text-black border-yellow-500', subCls: 'text-black/70' },
                    { label: 'Paid to You', value: rupees(money(paidList)), sub: `${paidList.length} paid`, cls: 'bg-emerald-600 text-white border-emerald-700', subCls: 'text-emerald-100' },
                    { label: 'From Members', value: rupees(money(commissions.filter((c) => !isVacancy(c)))), sub: '👤 referrals', cls: 'bg-white text-black border-yellow-200', subCls: 'text-gray-500' },
                    { label: 'From Vacancies', value: rupees(money(commissions.filter(isVacancy))), sub: '🏢 shared vacancies', cls: 'bg-white text-black border-yellow-200', subCls: 'text-gray-500' }
                  ].map((card) => (
                    <div key={card.label} className={`rounded-2xl border px-4 py-3 ${card.cls}`}>
                      <p className={`text-[10px] font-black uppercase tracking-[0.18em] ${card.subCls}`}>{card.label}</p>
                      <p className="mt-1 text-xl font-black">{card.value}</p>
                      <p className={`text-[11px] font-bold ${card.subCls}`}>{card.sub}</p>
                    </div>
                  ))}
                </div>

                <div className="mt-4 flex flex-wrap gap-2">
                  {[
                    { name: 'source', value: '', label: 'All sources' },
                    { name: 'source', value: 'member', label: '👤 Member referrals' },
                    { name: 'source', value: 'vacancy', label: '🏢 Shared vacancies' }
                  ].concat([
                    { name: 'status', value: '', label: 'Any status' },
                    { name: 'status', value: 'Pending', label: '⏳ Pending' },
                    { name: 'status', value: 'Paid', label: '✓ Paid' }
                  ]).map((chip) => {
                    const on = commissionFilter[chip.name] === chip.value;
                    return (
                      <button key={`${chip.name}-${chip.value}`} type="button" onClick={() => setCF(chip.name, chip.value)}
                        className={`rounded-full border px-3 py-1.5 text-xs font-black transition ${on ? 'border-black bg-black text-yellow-400' : 'border-yellow-200 bg-white text-black hover:bg-yellow-50'} ${chip.value === '' && chip.name === 'status' ? 'sm:ml-4' : ''}`}>
                        {chip.label}
                      </button>
                    );
                  })}
                </div>

                {commissionsLoading ? (
                  <div className="mt-4 text-sm text-gray-500 px-2">Loading commissions…</div>
                ) : commissions.length === 0 ? (
                  <div className="mt-4 rounded-2xl border border-dashed border-yellow-200 bg-yellow-50 px-4 py-8 text-center text-sm text-yellow-700 font-semibold">
                    No commissions yet. They appear automatically when a member you referred, or a candidate for a vacancy you shared, is placed.
                  </div>
                ) : shown.length === 0 ? (
                  <div className="mt-4 rounded-2xl border border-dashed border-yellow-200 bg-yellow-50 px-4 py-6 text-center text-sm text-yellow-700 font-semibold">No commissions match this filter.</div>
                ) : (
                  <div className="mt-4 space-y-3">
                    <div className="overflow-x-auto rounded-[22px] border border-yellow-200">
                      <table className="min-w-[960px] w-full text-left text-sm">
                        <thead>
                          <tr className="bg-yellow-400">
                            {['#', 'Placed On', 'Candidate', 'Source', 'Job & Company', 'Service Charge', 'Rate', 'Your Commission', 'Status'].map((h) => (
                              <th key={h} className="border-b border-yellow-500 px-3 py-2.5 text-xs font-black uppercase tracking-wider text-black">{h}</th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {pagedC.map((c, idx) => {
                            const amount = parseFloat(c.commission_amount || '0') || 0;
                            return (
                            <tr key={c.id} className="align-top odd:bg-white even:bg-yellow-50/40 hover:bg-yellow-50">
                              <td className="border-b border-yellow-100 px-3 py-3 text-xs text-gray-400 font-bold">{(safeCPage - 1) * PAGE_SIZE + idx + 1}</td>
                              <td className="border-b border-yellow-100 px-3 py-3 text-gray-500 whitespace-nowrap text-xs">{c.created_at ? c.created_at.slice(0, 10) : '-'}</td>
                              <td className="border-b border-yellow-100 px-3 py-3 font-black text-black">{c.member_name || '-'}</td>
                              <td className="border-b border-yellow-100 px-3 py-3">
                                <span className={`inline-flex whitespace-nowrap rounded-full border px-2 py-0.5 text-[11px] font-black ${isVacancy(c) ? 'border-blue-200 bg-blue-50 text-blue-700' : 'border-gray-200 bg-gray-50 text-gray-600'}`}>
                                  {isVacancy(c) ? '🏢 Shared vacancy' : '👤 Member referral'}
                                </span>
                              </td>
                              <td className="border-b border-yellow-100 px-3 py-3 text-gray-700">
                                <p className="font-semibold">{c.job_title || '-'}</p>
                                <p className="text-xs text-gray-500">{c.company || ''}</p>
                              </td>
                              <td className="border-b border-yellow-100 px-3 py-3 text-gray-700 whitespace-nowrap">{parseFloat(c.service_charge_amount || '0') > 0 ? `₹${Number(c.service_charge_amount).toLocaleString('en-IN')}` : '—'}</td>
                              <td className="border-b border-yellow-100 px-3 py-3 text-gray-700 whitespace-nowrap">{c.commission_percentage ? `${c.commission_percentage}%` : '-'}</td>
                              <td className="border-b border-yellow-100 px-3 py-3 whitespace-nowrap">
                                {amount > 0
                                  ? <span className="text-base font-black text-black">{rupees(amount)}</span>
                                  : <span className="text-xs font-bold text-orange-600">Awaiting service charge</span>}
                              </td>
                              <td className="border-b border-yellow-100 px-3 py-3">
                                {c.status === 'Paid' ? (
                                  <div className="flex flex-col items-start gap-1">
                                    <span className="inline-block whitespace-nowrap rounded-full bg-emerald-600 px-2.5 py-0.5 text-xs font-black text-white">
                                      ✓ Paid{c.paid_at ? ` · ${c.paid_at.slice(0, 10)}` : ''}
                                    </span>
                                    {c.transaction_screenshot && (
                                      <button type="button" onClick={() => openCommissionReceipt(c.id, localStorage.getItem('token'))}
                                        className="rounded-lg border border-yellow-300 bg-yellow-100 px-2 py-0.5 text-xs font-bold text-black hover:bg-yellow-200">
                                        🧾 View Receipt
                                      </button>
                                    )}
                                  </div>
                                ) : (
                                  <span className="inline-block whitespace-nowrap rounded-full border border-yellow-400 bg-yellow-50 px-2.5 py-0.5 text-xs font-black text-yellow-800">⏳ Pending payment</span>
                                )}
                              </td>
                            </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                    <Paginator page={safeCPage} total={shown.length} pageSize={PAGE_SIZE} onChange={setCommissionsPage} />
                  </div>
                )}
              </>
              );
            })()
            ) : (
              <>
                <div className="mt-4 flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
                  <div>
                    <p className="text-xs font-black uppercase tracking-[0.28em] text-yellow-600">Submitted Members</p>
                    <h2 className="mt-1 text-xl font-black text-black">Your member registrations</h2>
                  </div>
                  <div className="rounded-2xl border border-yellow-300 bg-yellow-50 px-4 py-2 text-sm font-black text-black">
                    Total: {registrations.length}
                  </div>
                </div>

                {registrations.length === 0 ? (
                  <div className="mt-4 rounded-2xl border border-dashed border-yellow-200 bg-yellow-50 px-4 py-8 text-center text-sm font-semibold text-yellow-700">
                    No members submitted yet.
                  </div>
                ) : (() => {
                  const safeMPage = Math.min(Math.max(membersPage, 1), Math.ceil(registrations.length / PAGE_SIZE));
                  const paged = registrations.slice((safeMPage - 1) * PAGE_SIZE, safeMPage * PAGE_SIZE);
                  return (
                  <div className="mt-4 space-y-3">
                    <div className="overflow-x-auto rounded-[22px] border border-yellow-200">
                      <table className="min-w-[1000px] w-full text-left text-sm">
                        <thead>
                          <tr className="bg-yellow-400">
                            {['#','Submitted','Name','Place / District','Qualification','Experience','Expecting Job','HR Status','Placement','Action'].map((h) => (
                              <th key={h} className="border-b border-yellow-500 px-3 py-2.5 text-xs font-black uppercase tracking-wider text-black">{h}</th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {paged.map((r, idx) => {
                            const hrStatus = r.hr_status;
                            const statusBadge = (() => {
                              if (!r.forwarded_to_hr) return { label: 'Pending Review', cls: 'bg-gray-100 text-gray-500 border-gray-200' };
                              if (!hrStatus || hrStatus === 'Waiting for the results') return { label: 'HR Reviewing', cls: 'bg-blue-100 text-blue-700 border-blue-200' };
                              if (hrStatus === 'Communicated') return { label: 'Communicated', cls: 'bg-cyan-100 text-cyan-700 border-cyan-200' };
                              if (hrStatus === 'Call Not Connected') return { label: 'Call Not Connected', cls: 'bg-orange-100 text-orange-700 border-orange-200' };
                              if (hrStatus === 'Call Later') return { label: 'Call Later', cls: 'bg-yellow-100 text-yellow-800 border-yellow-300' };
                              if (hrStatus === 'Interested') return { label: 'Interested ✓', cls: 'bg-emerald-100 text-emerald-700 border-emerald-200' };
                              if (hrStatus === 'Ready To Pay') return { label: 'Ready To Pay', cls: 'bg-green-100 text-green-700 border-green-200' };
                              if (hrStatus === 'Registration Fee Paid') return { label: 'Fee Paid ✓', cls: 'bg-black text-yellow-400 border-black' };
                              if (hrStatus === 'Prime Membership Fee Paid') return { label: 'Prime Paid 👑', cls: 'bg-yellow-400 text-black border-yellow-500' };
                              if (hrStatus === 'Partner Member') return { label: 'Partner Member 🤝', cls: 'bg-amber-400 text-black border-amber-500' };
                              if (hrStatus === 'Not Interested') return { label: 'Not Interested', cls: 'bg-red-100 text-red-700 border-red-200' };
                              if (hrStatus === 'Black Listed') return { label: 'Blacklisted', cls: 'bg-red-900 text-white border-red-900' };
                              if (hrStatus === 'Job Not Required') return { label: 'Job Not Required', cls: 'bg-gray-200 text-gray-600 border-gray-300' };
                              if (hrStatus === 'Not Attended') return { label: 'Not Attended', cls: 'bg-orange-100 text-orange-700 border-orange-200' };
                              if (hrStatus === 'Registration Fee Returned') return { label: 'Fee Returned', cls: 'bg-purple-100 text-purple-700 border-purple-200' };
                              return { label: hrStatus, cls: 'bg-gray-100 text-gray-600 border-gray-200' };
                            })();
                            return (
                            <tr key={r.id} className="align-top odd:bg-white even:bg-yellow-50/40 hover:bg-yellow-50">
                              <td className="border-b border-yellow-100 px-3 py-3 text-xs text-gray-400 font-bold">{(safeMPage - 1) * PAGE_SIZE + idx + 1}</td>
                              <td className="border-b border-yellow-100 px-3 py-3 text-gray-500 whitespace-nowrap text-xs">{r.created_at}</td>
                              <td className="border-b border-yellow-100 px-3 py-3 font-black text-black">
                                {r.name}
                                {r.remarks && <p className="mt-1 max-w-[220px] text-[11px] font-normal text-gray-500" title={r.remarks}>💬 {r.remarks.length > 60 ? `${r.remarks.slice(0, 60)}…` : r.remarks}</p>}
                                {r.voice_note_file && <audio controls preload="none" src={`${API_URL}${r.voice_note_file}`} className="mt-1 h-8 w-[200px]" />}
                              </td>
                              <td className="border-b border-yellow-100 px-3 py-3 text-gray-700">{r.place}{r.district ? `, ${r.district}` : ''}</td>
                              <td className="border-b border-yellow-100 px-3 py-3 text-gray-700">{r.qualification || '-'}</td>
                              <td className="border-b border-yellow-100 px-3 py-3 text-gray-700">{r.experience_level || '-'}</td>
                              <td className="border-b border-yellow-100 px-3 py-3 text-gray-700">{r.expecting_job || '-'}</td>
                              <td className="border-b border-yellow-100 px-3 py-3">
                                <span className={`inline-flex items-center rounded-full border px-2 py-0.5 text-[11px] font-black whitespace-nowrap ${statusBadge.cls}`}>
                                  {statusBadge.label}
                                </span>
                                {r.hr_staff_name && (
                                  <p className="mt-0.5 text-[10px] text-gray-400">{r.hr_staff_name}</p>
                                )}
                              </td>
                              <td className="border-b border-yellow-100 px-3 py-3">
                                {r.is_placed ? (
                                  <div>
                                    <span className="inline-flex items-center gap-1 rounded-full border border-emerald-600 bg-gradient-to-r from-emerald-500 to-green-600 px-2.5 py-0.5 text-[11px] font-black text-white whitespace-nowrap shadow-sm">
                                      🏆 PLACED ✓
                                    </span>
                                    {(r.placed_job_title || r.placed_company) && (
                                      <p className="mt-1 text-[11px] font-bold text-emerald-800">
                                        {[r.placed_job_title, r.placed_company].filter(Boolean).join(' @ ')}
                                      </p>
                                    )}
                                    {r.placed_at && <p className="text-[10px] text-gray-400">on {formatPlacedDate(r.placed_at)}</p>}
                                  </div>
                                ) : (
                                  <span className="inline-flex items-center rounded-full border border-gray-200 bg-gray-50 px-2 py-0.5 text-[11px] font-bold text-gray-400 whitespace-nowrap">
                                    Not placed yet
                                  </span>
                                )}
                              </td>
                              <td className="border-b border-yellow-100 px-3 py-3">
                                {r.forwarded_to_hr ? (
                                  <span className="inline-flex items-center gap-1 text-[11px] font-bold text-gray-400 whitespace-nowrap" title="Already sent to HR. Contact Dani Job Club to correct details.">🔒 Locked</span>
                                ) : (
                                  <button
                                    type="button"
                                    onClick={() => startEditMember(r)}
                                    className="inline-flex items-center gap-1 rounded-lg border border-blue-300 bg-blue-50 px-3 py-1.5 text-xs font-black text-blue-700 hover:bg-blue-100 whitespace-nowrap"
                                  >
                                    ✏️ Edit
                                  </button>
                                )}
                              </td>
                            </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                    <Paginator page={safeMPage} total={registrations.length} pageSize={PAGE_SIZE} onChange={setMembersPage} />
                  </div>
                  );
                })()}
              </>
            )}
          </div>
        </section>
      </div>

      {newPlacements.length > 0 && (
        <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/70 p-4 backdrop-blur-sm" role="dialog" aria-modal="true" aria-labelledby="placement-popup-title">
          <div className="placement-pop relative w-full max-w-md overflow-hidden rounded-[28px] border-2 border-yellow-400 bg-white text-center shadow-2xl">
            <div className="relative bg-gradient-to-br from-black via-gray-900 to-black px-6 pb-6 pt-8">
              {['✨', '🎉', '⭐', '🎊', '✨'].map((icon, i) => (
                <span key={i} className="placement-float absolute text-xl" style={{ left: `${10 + i * 20}%`, top: `${i % 2 ? 18 : 8}%`, animationDelay: `${i * 0.3}s` }} aria-hidden="true">{icon}</span>
              ))}
              <div className="placement-trophy mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-gradient-to-br from-yellow-300 to-amber-500 text-4xl shadow-lg ring-4 ring-yellow-200/40">🏆</div>
              <p className="mt-4 text-xs font-black uppercase tracking-[0.3em] text-yellow-400">Congratulations!</p>
              <h2 id="placement-popup-title" className="mt-1 text-2xl font-black text-white">
                {newPlacements.length === 1 ? 'Your candidate is placed' : `${newPlacements.length} candidates are placed`}
              </h2>
            </div>

            <div className="max-h-[40vh] space-y-2 overflow-y-auto px-6 py-5">
              {newPlacements.map((r) => (
                <div key={r.id} className="rounded-2xl border border-emerald-200 bg-emerald-50 px-4 py-3 text-left">
                  <div className="flex items-center justify-between gap-2">
                    <span className="font-black text-black">{r.name}</span>
                    <span className="rounded-full bg-emerald-600 px-2 py-0.5 text-[10px] font-black text-white">PLACED ✓</span>
                  </div>
                  {(r.placed_job_title || r.placed_company) && (
                    <p className="mt-1 text-sm font-semibold text-emerald-800">{[r.placed_job_title, r.placed_company].filter(Boolean).join(' @ ')}</p>
                  )}
                  {r.placed_at && <p className="text-xs text-gray-500">Placed on {formatPlacedDate(r.placed_at)}</p>}
                </div>
              ))}
              <p className="pt-1 text-center text-xs text-gray-500">Your commission for this placement is added to <b>My Commissions</b>.</p>
            </div>

            <div className="flex gap-2 border-t border-yellow-100 px-6 py-4">
              <button
                type="button"
                onClick={() => {
                  setNewPlacements([]);
                }}
                className="flex-1 rounded-xl border border-gray-300 px-4 py-2.5 text-sm font-black text-black hover:border-yellow-400"
              >
                OK
              </button>
              <button
                type="button"
                onClick={() => {
                  setNewPlacements([]);
                  setActiveTab('commissions');
                  setCommissionsPage(1);
                  fetchCommissions();
                }}
                className="flex-1 rounded-xl bg-yellow-400 px-4 py-2.5 text-sm font-black text-black hover:bg-yellow-300"
              >
                💰 View Commissions
              </button>
            </div>
          </div>
        </div>
      )}

      <PartnerChatWidget />
    </div>
  );
};

export default PartnerDashboard;
